import React from "react";
import { CREDENTIALS } from "../data/mock";

export const CredentialsBar = () => {
  return (
    <section
      data-testid="credentials-bar"
      className="bg-navy text-ivory py-6 border-y border-gold/20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 lg:gap-x-14">
          {CREDENTIALS.map((cred, idx) => (
            <div
              key={cred}
              data-testid={`credential-${idx}`}
              className="flex items-center gap-3"
            >
              <div className="w-1 h-1 rounded-full bg-gold" />
              <span className="text-[11px] sm:text-xs uppercase tracking-[0.22em] text-ivory/85 font-medium whitespace-nowrap">
                {cred}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
